<div class="flex items-center">
  {{ headerTitle }}
  <button
    class="cursor-pointer ms-2"
    (click)="onHeaderClicked()"
    appAgentAction
    [agent]="'header-sorter-sort-' + field"
    action="sort"
  >
    @if (arrow === arrows.BOTH) {
      <app-up-down-chevron-icon></app-up-down-chevron-icon>
    } @else {
      <app-chevron-icon [direction]="arrow"></app-chevron-icon>
    }
  </button>
</div>
